document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.getElementById('shortsCarousel');
  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');
  const dotsContainer = document.getElementById('carouselDots');
  const items = carousel.querySelectorAll('.short-item');
  
  let currentIndex = 0;
  
  // Create dots
  items.forEach((_, index) => {
    const dot = document.createElement('button');
    dot.className = 'carousel-dot';
    if (index === 0) dot.classList.add('active');
    dot.addEventListener('click', () => goToSlide(index));
    dotsContainer.appendChild(dot);
  });
  
  const dots = dotsContainer.querySelectorAll('.carousel-dot');
  
  function updateCarousel() {
    const offset = -currentIndex * 100;
    carousel.style.transform = `translateX(${offset}%)`;
    
    // Update dots
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === currentIndex);
    });
    
    // Update button states
    prevBtn.style.opacity = currentIndex === 0 ? '0.3' : '0.8';
    nextBtn.style.opacity = currentIndex === items.length - 1 ? '0.3' : '0.8';
  }
  
  function goToSlide(index) {
    currentIndex = index;
    updateCarousel();
  }
  
  function showNext() {
    if (currentIndex < items.length - 1) {
      currentIndex++;
      updateCarousel();
    }
  }
  
  function showPrev() {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  }
  
  nextBtn.addEventListener('click', showNext);
  prevBtn.addEventListener('click', showPrev);
  
  // Enhanced Touch/Swipe support
  let touchStartX = 0;
  let touchStartY = 0;
  let touchEndX = 0;
  let touchEndY = 0;
  let isDragging = false;
  
  carousel.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
    touchStartY = e.changedTouches[0].screenY;
    isDragging = true;
  }, { passive: true });
  
  carousel.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    
    const currentX = e.changedTouches[0].screenX;
    const diffX = touchStartX - currentX;
    const diffY = Math.abs(touchStartY - e.changedTouches[0].screenY);
    
    // Only handle horizontal swipes
    if (Math.abs(diffX) > diffY) {
      e.preventDefault();
    }
  }, { passive: false });
  
  carousel.addEventListener('touchend', (e) => {
    if (!isDragging) return;
    
    touchEndX = e.changedTouches[0].screenX;
    touchEndY = e.changedTouches[0].screenY;
    handleSwipe();
    isDragging = false;
  });
  
  function handleSwipe() {
    const diffX = touchStartX - touchEndX;
    const diffY = Math.abs(touchStartY - touchEndY);
    
    // Only handle horizontal swipes
    if (Math.abs(diffX) > diffY && Math.abs(diffX) > 50) {
      if (diffX > 0) {
        showNext();
      } else {
        showPrev();
      }
    }
  }
  
  // Initialize
  updateCarousel();
});